// extracted by css-extract-rspack-plugin
export default {"cls1":"ActiveState-cls1_Q6m","cls2":"ActiveState-cls2_sv0 ActiveState-cls1_Q6m"};